// @flow
import * as React from 'react';
import { Box } from '@locus-taxy/neo-ui';
import Switch from '../../components/Switch';
type Props = {
    allowReschedule: boolean,
    onChange: () => void,
    getString: (key: string) => string
};

const StatusEnabler = ({
    allowReschedule,
    onChange,
    getString
}: Props): React.Node => {
    return (
        <Box borderRadius="4px" backgroundColor="white" padding={4} mb={4}>
            <Switch
                value={allowReschedule}
                onChange={onChange}
                label={getString('enabled.label')}
                description={getString('enabled.description')}
            />
        </Box>
    );
};

export default StatusEnabler;
